import { useEffect } from 'react';
import UnidadForm from '../../components/unidades/UnidadForm';
import { useUnidadesStore, type RegistrarUnidad } from '../../stores/unidades/unidades.store';

const AgregarUnidad = () => {
  const { current: unidad, nuevo, registrar } = useUnidadesStore((state) => state);

  useEffect(() => {
    nuevo();
  }, []);

  const handleSave = (values: RegistrarUnidad) => {
    return registrar(values);
  };

  return <UnidadForm esAgregar={true} unidad={unidad} onSave={handleSave} />;
};

export default AgregarUnidad;
